/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KsqlCommand
 */
export interface KsqlCommand {
    /**
     * 
     * @type {string}
     * @memberof KsqlCommand
     */
    ksql: string;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof KsqlCommand
     */
    streamsProperties?: { [key: string]: string | undefined; };
}

export function KsqlCommandFromJSON(json: any): KsqlCommand {
    return KsqlCommandFromJSONTyped(json, false);
}

export function KsqlCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): KsqlCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ksql': json['ksql'],
        'streamsProperties': !exists(json, 'streamsProperties') ? undefined : json['streamsProperties'],
    };
}

export function KsqlCommandToJSON(value?: KsqlCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ksql': value.ksql,
        'streamsProperties': value.streamsProperties,
    };
}

